import BrowserUnsupported from './BrowserUnsupported';
export default BrowserUnsupported;
